// extracted by mini-css-extract-plugin
export default {"processingTranscription":"TabProcessingTranscription_processingTranscription__FgRVY"};